import React, { useState, useEffect } from 'react'
import ParentsHeader from '../../components/Header/ParentsHeader'
import SquarePayment from '../../components/SquarePayment/SquarePayment'
import parentscheckoutStyle from './ParentsCheckout.module.css'
import BackBar from '../../components/BackBar/BackBar'
import SideBar from '../../components/Sidebar/SideBar'
import { useMediaQuery } from 'react-responsive';
import { useCart } from '../../../context/CartContext';
import { FiTrash2 } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import bookss from '../../../assets/images/books.png'
import OrdersummaryInfo from '../../components/ordersummaryComponent/ordersummaryInfo'
import ParentsInfo from '../../components/parentsinfomationComponent/parentsInfo'
import PaymentInfo from '../../components/paymentinfomationComponent/paymentInfo'
require('typeface-poppins')

export default function ParentsCheckout() {
  const [parentFirstName, setParentFirstName] = useState('');
  const [parentLastName, setParentLastName] = useState('');
  const [parentEmail, setParentEmail] = useState('');
  const [parentPhone, setParentPhone] = useState('');
  const { cart, removeFromCart, updateQuantity, clearCart, updateInscription } = useCart();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [total, setTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [inscriptions, setInscriptions] = useState([]);
  const [paymentToken, setPaymentToken] = useState(null);
  const [loading, setLoading] = useState(false);
  /*const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvv, setCvv] = useState('');
  const [zipCode, setZipCode] = useState('');*/
  // const [parentFirstName, setParentFirstName] = useState('');


  const navigate = useNavigate();


  /* useEffect(() => {
     parentFirstName,
     parentLastName,
     parentEmail,
     parentPhone
     // Calculate total whenever cart changes
     const newTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
     console.log(newTotal,'hhhhhh');
     const newTax = 0; // Set tax to 0 as per current implementation
     const newGrandTotal = newTotal + newTax;
     
     setTotal(newTotal);
     setTax(newTax);
     setGrandTotal(newGrandTotal);
   }, [cart,parentFirstName, parentLastName, parentEmail, parentPhone]); */

  useEffect(() => {
    // Calculate total whenever cart or parent info changes
    const newTotal = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    // console.log(newTotal,'hhhhhh');

    const newTax = 0;
    const newGrandTotal = newTotal + newTax;

    setTotal(newTotal);
    setTax(newTax);
    setGrandTotal(newGrandTotal);

  }, [cart]);

  /* useEffect(() => {
    setInscriptions(prev => {
      const updated = [...prev];
  
      // Only add new entries, don't reset old ones
      cart.forEach((_, i) => {
        if (!updated[i]) {
          updated[i] = {
            inscription_name: "",
            student_name: "",
            teacher_name: "",
            grade_level: ""
          };
        }
      });
  
      // Trim if cart shrinks
      updated.length = cart.length;
  
      return updated;
    });
  }, [cart]);*/


  const handleQuantityChange = (bookId, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(bookId, newQuantity);
    }
  };

  /*const prepareToPay = () => {
    const data = {
      fName: parentFirstName,
      lName: parentLastName,
      email: parentEmail,
      phone: parentPhone
    };

    localStorage.setItem("PARENT_INFO_TEMP", JSON.stringify(data));
  };*/

  /*const updateInscription = (i, key, value) => {
    const copy = [...inscriptions];
    copy[i][key] = value;
    setInscriptions(copy);
  };*/

  /* const updateInscription = (bookId, key, value) => {
    setCart(prev =>
      prev.map(item =>
        item.book_id === bookId
          ? {
              ...item,
              inscription: {
                ...item.inscription,
                [key]: value
              }
            }
          : item
      )
    );
  }; */

  const handleSaveInscription = (bookId, inscription) => {
    Object.keys(inscription).forEach(key => {
      updateInscription(bookId, key, inscription[key]);
    });
    alert("Inscription saved!");
  };

  const placeOrder = async () => {

    //console.log("PAY TOKEN:", data);

    //  Force sync cart inscriptions before sending order
    /*cart.forEach(item => {
      Object.keys(item.inscription).forEach(key => {
        updateInscription(item.book_id, key, item.inscription[key]);
      });
    });
  
    // Wait for state + localStorage sync
    await new Promise(res => setTimeout(res, 50));
  
    console.log("FINAL CART SENT TO API:", cart);*/

    /* console.log("PARENT VALUES:", {
       firstName: data.firstName,
       lastName: data.lastName,
       email: data.email,
       phone: data.phone,
     });*/
    /*const firstName = data.firstName;
    const lastName = data.lastName;
    const email = data.email;
    const phone = data.phone;*/
    //alert(firstName,lastName);
    /*if (firstName=='' || lastName=='' || email=='' || phone=='') {
      alert("Please fill in all parent information fields!");
      return;
    }*/

    /*if (!cardNumber || !expiry || !cvv || !zipCode) {
        alert("Please fill in all payment information fields!");
        return;
    }*/

    if (cart.length === 0) {
      alert("Your cart is empty!");
      return;
    }

    if (
      !parentFirstName?.trim() ||
      !parentLastName?.trim() ||
      !parentEmail?.trim() ||
      !parentPhone?.trim()
    ) {
      alert("Parent information is required!");
      return;
    }

    // Inscription validation (MANDATORY for each cart item)
    const missingInscription = cart.some(item => {
      // If inscription object is empty OR has empty values
      if (!item.inscription || Object.keys(item.inscription).length === 0) {
        return true;
      }

      return Object.values(item.inscription).some(
        value => !value || value.trim() === ""
      );
    });

    if (missingInscription) {
      alert("Inscription detail is required for all items!");
      return;
    }

    //console.log(cart ,'cccccart');

    const subTotall = cart.reduce((sum, item) => {
      return sum + (Number(item.price) * Number(item.quantity));
    }, 0);

    //const tax = subTotal * 0.07; // or whatever tax % your system uses
    const tax = 0;
    const grandTotall = subTotall + tax;

    const orderData = {
      user_id: localStorage.getItem('userId') || '',
      event_id: localStorage.getItem('currentEventId') || '',
      /*cart: cart.map(item, index) => ({
        book_id: item.book_id,
        quantity: item.quantity,
        price: item.price,
        author_id: item.author_id,
        inscription: inscriptions[index]
      })),*/
      cart: cart.map(item => ({
        book_id: item.book_id,
        quantity: item.quantity,
        price: item.price,
        title: item.title,
        author_id: item.author_id,
        inscription: item.inscription     //  Correct every time
      })),
      /*cart: cart.map((item, index) => ({
        book_id: item.book_id,
        quantity: item.quantity,
        price: item.price,
        author_id: item.author_id,

        // Add this ⬇
        inscription: inscriptions[index] || {}  
      })),*/
      /*payment_details: {
        token:data.token
      },*/
      payment: {
        sourceId: paymentToken
      },
      parent_info: {
        first_name: parentFirstName,
        last_name: parentLastName,
        email: parentEmail,
        phone: parentPhone
      },
      order_summary: {
        sub_total: grandTotall.toFixed(2),
        tax: tax.toFixed(2),
        grand_total: grandTotall.toFixed(2)
      }
    };

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/process-order.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderData)
      });

      const result = await response.json();

      if (result.status == 'success') {
        alert("Order placed successfully!");
        clearCart();
        const orderNumber = result.order_number;
        navigate(`/PurchaseSummaryPage/${orderNumber}`);
        /*navigate('/PurchaseSummaryPage', { 
          state: { 
           // orderData: result.orderData, 
           orderData: orderData, 
            cartItems: cart 
          } 
        });*/

        // navigate('/PurchaseSummary', { state: { orderData: result.orderData } });
        // Optionally redirect to a success page
      } else {
        alert(result.message || "Failed to place order. Please try again.");
      }
    } catch (error) {
      console.error("Order error:", error);
      alert("Something went wrong. Please try again.");
    }
    finally {
      setLoading(false);  //  enable button again
    }
  };

  const handlePaymentSubmit = async (sourceId) => {
    setPaymentToken(sourceId); // Save sourceId for later use
  };

  /* const handlePaymentSubmittt = async (sourceId) => {
     const calcTotal = cart.reduce((sum, item) => 
       sum + (item.price * item.quantity), 0
     );
     
     const calcTax = 0;
     const calcGrand = calcTotal + calcTax;
 
     const orderData = {
       user_id: localStorage.getItem('userId') || '', 
       event_id: localStorage.getItem('currentEventId') || '',
       cart: cart.map(item => ({
         book_id: item.book_id,
         quantity: item.quantity,
         price: item.price,
         author_id: item.author_id
       })),
       payment_details: {
         card_number: cardNumber,
         expiry: expiry,
         cvv: cvv,
         zip_code: zipCode
       },
       parent_info: {
         first_name: parentFirstName,
         last_name: parentLastName,
         email: parentEmail,
         phone: parentPhone
       },
       order_summary: {
         sub_total: calcTotal.toFixed(2),
         tax: tax.toFixed(2),
         grand_total: calcGrand.toFixed(2)
       }
     };
 
     const payload = {
       cart,
       parent_info: {
         first_name: parentFirstName,
         last_name: parentLastName,
         email: parentEmail,
         phone: parentPhone
       },
       event_id: localStorage.getItem('currentEventId') || '',
       order_summary: {
         sub_total: calcTotal.toFixed(2),
         calcTax,
         grand_total: calcGrand.toFixed(2)
       },
       payment: {
         sourceId
       }
     };
 
     const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/process-order.php`, {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify(payload)
     });
 
     const data = await res.json();
     if (data.status =='success') {
         alert("Order placed successfully!");
         clearCart();
         navigate('/PurchaseSummaryPage', { 
           state: { 
             orderData: data.orderData, 
             cartItems: cart 
           } 
         });
 
        // navigate('/PurchaseSummary', { state: { orderData: result.orderData } });
         // Optionally redirect to a success page
       } else {
         //alert(result.message || "Failed to place order. Please try again.");
         alert(data.message);
       }
     
   };*/



  return (
    <>
      <ParentsHeader />
      <div className={parentscheckoutStyle.parentscheckoutPage}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            {isMobile ? (
              undefined
            ) : (
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar />
              </div>
            )}

            <div className='col'>
              {isMobile ? (
                <div className={parentscheckoutStyle.mobilcheckoutContainer}>
                  <OrdersummaryInfo />
                  <ParentsInfo />
                  <PaymentInfo />
                </div>
              ) : (
                <div className={parentscheckoutStyle.checkoutContainer}>
                  <div className='row g-0'>
                    <div className='col-sm-8'>
                      <div className={parentscheckoutStyle.checkoutWrapper}>
                        {cart.length === 0 ? (
                          <div className={parentscheckoutStyle.checkoutInner}>
                            <h4 className={parentscheckoutStyle.checkoutTitle}>Your cart is empty</h4>
                          </div>
                        ) : (
                          cart.map((item, index) => (
                            <div key={item.book_id} className={parentscheckoutStyle.checkoutInner} style={{ borderBottom: '1px solid #C1C1C1' }}>
                              <h4 className={parentscheckoutStyle.checkoutTitle}>Checkout</h4>
                              <div className='row'>

                                <div className='col-lg-3'>
                                  <div className={parentscheckoutStyle.incriptionImg}>
                                    <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/ProductImages/${item.book_id}.jpg`} className='img-fluid mb-4' alt={item.title} />
                                  </div>
                                </div>
                                <div className='col-lg-9'>
                                  <div className='d-flex align-items-start'>
                                    <div className={`${parentscheckoutStyle.incriptionDetailone} mb-3`}>
                                      <h4 className={parentscheckoutStyle.incriptionTitle}>{item.title}</h4>
                                      <p className={parentscheckoutStyle.incriptionCover}>{item.format}</p>
                                      <span className={parentscheckoutStyle.incriptionPrice}>${item.price}</span>
                                    </div>
                                    <div className='ms-auto d-flex align-items-start'>
                                      <select
                                        className="form-select"
                                        value={item.quantity}
                                        onChange={(e) => handleQuantityChange(item.book_id, parseInt(e.target.value))}
                                        style={{ border: '1px solid #C1C1C1', width: '80px', font: 'normal normal 400 15px/21px Poppins', borderRadius: '0px' }}
                                      >
                                        {[1, 2, 3, 4, 5].map(num => (
                                          <option key={num} value={num}>{num}</option>
                                        ))}
                                      </select>
                                      <div onClick={() => removeFromCart(item.book_id)} style={{ cursor: 'pointer' }}>
                                        <FiTrash2 className={parentscheckoutStyle.trashIcon} />
                                      </div>
                                    </div>
                                  </div>

                                  <div className={parentscheckoutStyle.incriptionDetailtwo} >
                                    {/* {cart.map((item, index) => (  */}
                                    <div key={item.book_id}>
                                      <h5 className={parentscheckoutStyle.incriptionsubTitle}> Inscription Details {item.book_id}</h5>
                                      <div className='row' key={item.book_id}>
                                        <div className="col-sm-6 mb-3">
                                          <input type="text" className="form-control" placeholder='Enter inscription name' style={{ borderRadius: '0px', font: 'normal normal 400 12px/21px Poppins', color: '#C1C1C1' }} value={item.inscription?.inscription_name || ""} onChange={(e) =>
                                            updateInscription(item.book_id, "inscription_name", e.target.value)
                                          } />
                                        </div>
                                        <div className="col-sm-6 mb-3">
                                          <input type="text" className="form-control" placeholder='Enter student full name' style={{ borderRadius: '0px', font: 'normal normal 400 12px/21px Poppins', color: '#C1C1C1' }} value={item.inscription?.student_name || ""} onChange={(e) =>
                                            updateInscription(item.book_id, "student_name", e.target.value)
                                          } />
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className="col-sm-6 mb-4">
                                          <input type="text" className="form-control" placeholder='Enter Teachers name' style={{ borderRadius: '0px', font: 'normal normal 400 12px/21px Poppins', color: '#C1C1C1' }} value={item.inscription?.teacher_name || ""} onChange={(e) =>
                                            updateInscription(item.book_id, "teacher_name", e.target.value)
                                          } />
                                        </div>
                                        <div className="col-sm-6 mb-4">
                                          <input type="text" className="form-control" placeholder='Grade level' style={{ borderRadius: '0px', font: 'normal normal 400 12px/21px Poppins', color: '#C1C1C1' }} value={item.inscription?.grade_level || ""} onChange={(e) =>
                                            updateInscription(item.book_id, "grade_level", e.target.value)
                                          } />
                                        </div>
                                      </div>
                                      <div className='row'>
                                        <div className='col-sm-12'>
                                          <button type='button' className='btn btn-primary' style={{ width: '195px', backgroundColor: '#1A58FF', borderColor: '#1A58FF', font: 'normal normal 400 15px/21px Poppins' }} onClick={() => handleSaveInscription(item.book_id, item.inscription)} >Save Info</button>
                                        </div>

                                      </div>
                                    </div>
                                    {/* ))} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                        <div className={parentscheckoutStyle.checkoutInnerNote}>
                          <div className='row'>
                            <div className='col-lg-10'>
                              <h5 className={parentscheckoutStyle.importantTitle}> Important Note: </h5>
                              <p className={parentscheckoutStyle.importantsubTitle}>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-sm-4'>
                      <div className={parentscheckoutStyle.orderSummary}>
                        <h4 className={parentscheckoutStyle.ostitle}>Order Summary</h4>
                        <div className={parentscheckoutStyle.ossubboxone}>
                          <div className='d-flex'>
                            <h6>Subtotal:</h6>
                            <span className='ms-auto'>${total.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className={parentscheckoutStyle.ossubboxone}>
                          <div className='d-flex'>
                            <h6>Tax:</h6>
                            <span className='ms-auto'>${tax.toFixed(2)}</span>
                          </div>
                        </div>
                        <div className={parentscheckoutStyle.ossubboxtwo}>
                          <div className='d-flex'>
                            <h6>Grand Total:</h6>
                            <span className='ms-auto'>${grandTotal.toFixed(2)}</span>
                          </div>
                        </div>
                        <h5 className={parentscheckoutStyle.parentInfoTitle}>Parents Information</h5>
                        <div className={parentscheckoutStyle.osfeilds}>
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Parent First Name'
                              value={parentFirstName}
                              onChange={(e) => setParentFirstName(e.target.value)}
                              style={{ borderRadius: '0px', font: 'normal normal 400 12px/18px Poppins', color: '#C1C1C1' }}
                            />
                          </div>
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder='Parent Last Name'
                              value={parentLastName}
                              onChange={(e) => setParentLastName(e.target.value)}
                              style={{ borderRadius: '0px', font: 'normal normal 400 12px/18px Poppins', color: '#C1C1C1' }}
                            />
                          </div>
                          <div className="mb-3">
                            <input
                              type="email"
                              className="form-control"
                              placeholder='Parent Email'
                              value={parentEmail}
                              onChange={(e) => setParentEmail(e.target.value)}
                              style={{ borderRadius: '0px', font: 'normal normal 400 12px/18px Poppins', color: '#C1C1C1' }}
                            />
                          </div>
                          <div className="mb-3">
                            <input type="number" className="form-control" placeholder='Parent Phone Number' value={parentPhone}
                              onChange={(e) => setParentPhone(e.target.value)} style={{ borderRadius: '0px', font: 'normal normal 400 12px/18px Poppins', color: '#C1C1C1' }} />
                          </div>
                        </div>
                        <h6 className={parentscheckoutStyle.paymentInfoTitle}>Payment Information</h6>
                        <SquarePayment
                          parentFirstName={parentFirstName}
                          parentLastName={parentLastName}
                          parentEmail={parentEmail}
                          parentPhone={parentPhone}
                          onTokenReceived={(token) => handlePaymentSubmit(token)}
                        />
                        {/* <div className=''>
                        <button type='button' onClick={handlePaymentSubmit} className='btn btn-success w-100' style={{backgroundColor: '#02A702', font: 'normal normal 400 14px/21px Poppins',borderColor: '#02A702'}}>Submit Payment</button>
                      </div> */}
                        {/* Show "Place Order" only after token is received */}
                        {paymentToken && (
                          <button
                            type="button"
                            onClick={placeOrder}
                            className="btn btn-success w-100 mt-3"
                            disabled={loading}   // disable when loading
                            style={{
                              backgroundColor: loading ? "#6c757d" : "#02A702",  // optional: grey color
                              borderColor: loading ? "#6c757d" : "#02A702",
                            }}
                          >
                            {loading ? "Placing Order..." : "Place Order"}   {/* button text change */}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
